import { Injectable, inject } from '@angular/core';
import { UploadDownloadService } from '@shared/services/upload-download.service';

/**
 * Fotos de los catálogos (Insumos, Equipos, Instrumental) para los
 * inventarios. En la base se guarda la key de S3 (`image`); para pintarla hace
 * falta una URL firmada que caduca en 1 h, así que se firma una sola vez por
 * key y se reutiliza ~50 min.
 */
@Injectable({ providedIn: 'root' })
export class CatalogImageService {
  private readonly files = inject(UploadDownloadService);
  private readonly cache = new Map<string, { at: number; url: Promise<string> }>();
  private static readonly TTL = 50 * 60 * 1000;

  /** URL lista para <img>, o '' si no hay foto / no se pudo firmar. */
  url(key: any): Promise<string> {
    const k = String(key ?? '').trim();
    if (!k) return Promise.resolve('');
    if (/^(https?:|data:)/i.test(k)) return Promise.resolve(k);
    const hit = this.cache.get(k);
    if (hit && Date.now() - hit.at < CatalogImageService.TTL) return hit.url;
    const url = this.files.presign(k)
      .then(f => f?.url ?? '')
      .catch(() => '');
    this.cache.set(k, { at: Date.now(), url });
    return url;
  }

  /** Llena `item[target]` con la URL de la foto de cada elemento. */
  async resolve(items: any[], keyOf: (item: any) => any, target = '_image'): Promise<void> {
    await Promise.all((items ?? []).map(async item => {
      if (!item) return;
      item[target] = await this.url(keyOf(item));
    }));
  }
}
